import React,{useEffect, useState} from 'react'
import axios from 'axios';

const OatTrainerpageMain = () => {


    useEffect(()=>{
        GetDept()
      
      },[])



    const [allusers1,setAllusers1]= useState([])
    const [Department,SetDepartment]= useState([])

    function GetDept(){
     
      
          fetch(`https://localhost:44326/api/OatTask/GetTrainerName`,{
      
            method:"GET",
            headers:{
              "Content-type": "application/json",
      
              "Accept": "application/json",
        
             
        
              "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
            },
               //body:JSON.stringify(data)
      
          }).then(response=> response.json())
          .then(data=>{
            console.log("Data",data)
            setAllusers1(data)
            
          });
          console.log("check",allusers1)
        }
      

      function handledepartment(){

       var Training_Id = document.getElementById("Trainer_Id").value

       console.log('asdfg',Training_Id);
       const data =
  {
    
    training_Id:Training_Id
  }
  console.log('asdfg',data);


  fetch("https://localhost:44326/api/OatTask/SelectTrainerDetail",{

  
         method:"POST",
        
        
         headers: {
                "Content-type": "application/json"
            
          },
          body:data,

        })
      
 
      .then((response) =>{
        console.log(response.data,"dfghjkl;");
   
   
        SetDepartment(response.data);

    
     })
     .catch(error => {
       console.log(error);
       
     })

      }


  return (
    <div>

    <div class="container">
<form action="action_page.php">
  <div class="row">
    <div class="col-25">
      {/* <label for="fname">First Name</label> */}
    </div>
    <div class="col-75">
        
    <select  name="Department"  className="form-select" onInputCapture={handledepartment}  id="Trainer_Id" >
<option>TrainerName</option>
    {allusers1.map((e)=>{
  return<option  value={e.training_ID}>{e.trainerName}</option>})}

{/* <option value="02">Team mate</option> */}

{/* {Roletable.map((e)=>
{
 return<option value={e.role}>{e.role}</option> })} */}
            

</select>    
    </div>

    <br></br> <br></br><br></br> <br></br>



    <div className='Paro-AddRoletable'>
        <div class="Paro-table-responsive">
       
        
        {Department.map((e)=>
            {
              return<table> 
    <thead>
   <tr>
<th>Department</th>
<th>TrainingItem</th>
<th>Start Date</th>
<th>End Date</th>

</tr>
</thead>

<tbody>

<tr>
                <td>{e.department}</td>
              <td>{e.trainingitem}</td>
              <td>{e.startDate}</td>
              <td>{e.endDate}</td>
              </tr>
       

          



           

</tbody>


</table>
  

})} 
        
  </div>


    </div>

 
  </div>
  </form>

  </div>

  </div>
 
  )
}

export default OatTrainerpageMain